import React, { useState, useEffect } from 'react';
import { Wordmark } from './Icons';
import '../AddToHomeScreen.css';

function AddToHomeScreen() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if app is already installed (running as PWA)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                        window.navigator.standalone ||
                        document.referrer.includes('android-app://');

    if (isStandalone) {
      setShowPrompt(false);
      return;
    }

    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    const hasSeenPrompt = localStorage.getItem('a2hs-dismissed');
    if (hasSeenPrompt) {
      return;
    }

    setTimeout(() => {
      setShowPrompt(true);
    }, 1000);

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;

      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
      setDeferredPrompt(null);
    }
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="a2hs-overlay">
      <div className="a2hs-modal">
        <Wordmark size={24} />

        <h2 className="a2hs-title">Install to continue</h2>
        <p className="a2hs-subtitle">
          Rapid Contact runs as an app on your home screen. Install it to get started.
        </p>

        {isIOS ? (
          <ol className="a2hs-instructions">
            <li className="a2hs-step">
              Tap the <strong>three dots (•••)</strong> in the bottom right
            </li>
            <li className="a2hs-step">
              Tap <strong>Share</strong>
            </li>
            <li className="a2hs-step">
              Scroll down and tap <strong>Add to Home Screen</strong>
            </li>
            <li className="a2hs-step">
              Tap <strong>Add</strong> in the top right
            </li>
          </ol>
        ) : (
          <button className="btn btn-primary btn-block" onClick={handleInstallClick}>
            Install app
          </button>
        )}
      </div>
    </div>
  );
}

export default AddToHomeScreen;
